import {
    LOADING_DATA_SLIDER,
    SET_DATA_SLIDER,
    SET_ERROR_SLIDER
} from '../types'

const initialState = {
    loadingslider: false,
    slider: {},
    message: '',
    error: ''
}


export default function (state = initialState, action) {
    switch (action.type) {
        case LOADING_DATA_SLIDER:
            return {
                ...state,
                loadingslider: true
            }
        case SET_DATA_SLIDER:
            return {
                loadingslider: false,
                ...action.payload
            }
        case SET_ERROR_SLIDER:
            return {
                loadingproyectos: false,
                ...action.payload
            }
        default: return state
    }
}